(() => {
  const configEl = document.querySelector('[data-huo-carousel-config]');
  if (!configEl) return;

  const autoplay = configEl.dataset.autoplay === 'true';
  const speed = Math.max(3000, (parseFloat(configEl.dataset.speed) || 6) * 1000);
  const motionHint = configEl.dataset.hint === 'true';
  const pauseOnHover = configEl.dataset.pauseHover !== 'false';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion) return;

  const timers = new WeakMap();
  const hinted = new WeakSet();

  function nativeTrackStep(track) {
    const first = track.children && track.children[0];
    if (!first) return Math.max(240, track.clientWidth * 0.82);
    const style = getComputedStyle(track);
    const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
    return first.getBoundingClientRect().width + gap;
  }

  function nativeAdvance(track) {
    if (track.scrollWidth <= track.clientWidth + 8) return;
    const max = track.scrollWidth - track.clientWidth;
    const step = nativeTrackStep(track);
    if (track.scrollLeft >= max - Math.max(12, step * 0.25)) {
      track.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      track.scrollBy({ left: step, behavior: 'smooth' });
    }
  }

  function ringAdvance(root) {
    if (root.matches('.huo-ring[data-scroll-pinned="true"]') && window.matchMedia('(min-width: 768px)').matches) return;
    const instance = root._huoRing;
    if (instance) {
      if (typeof instance.goToIndex === 'function') instance.goToIndex((instance.active || 0) + 1);
      else if (typeof instance.goTo === 'function') instance.goTo((instance.active || 0) + 1);
      return;
    }
    root.querySelector('[data-ring-next]')?.click();
  }

  function splideAdvance(el) {
    if (el.getAttribute('data-autoplay') === 'true') return;
    if (el.closest('.shopify-section-product-section')) return;
    if (el.slider && typeof el.slider.go === 'function') el.slider.go('>');
    else el.querySelector('.splide__arrow--next:not(:disabled)')?.click();
  }

  function stop(target) {
    const id = timers.get(target);
    if (id) clearInterval(id);
    timers.delete(target);
  }

  function start(target, advance) {
    stop(target);
    if (!autoplay || document.hidden) return;
    timers.set(target, window.setInterval(() => {
      if (!document.hidden) advance(target);
    }, speed));
  }

  function bindPause(target, advance) {
    target.addEventListener('pointerdown', () => stop(target), { passive: true });
    target.addEventListener('pointerup', () => start(target, advance), { passive: true });
    target.addEventListener('touchend', () => start(target, advance), { passive: true });
    target.addEventListener('focusin', () => stop(target));
    target.addEventListener('focusout', () => start(target, advance));
    if (pauseOnHover) {
      target.addEventListener('mouseenter', () => stop(target));
      target.addEventListener('mouseleave', () => start(target, advance));
    }
    start(target, advance);
  }

  function hintNative(track) {
    if (hinted.has(track) || track.scrollWidth <= track.clientWidth + 8) return;
    hinted.add(track);
    const amount = Math.min(16, Math.max(10, track.clientWidth * 0.025));
    track.scrollBy({ left: amount, behavior: 'smooth' });
    window.setTimeout(() => track.scrollBy({ left: -amount, behavior: 'smooth' }), 520);
  }

  function hintRing(root) {
    if (hinted.has(root)) return;
    hinted.add(root);
    if (root.matches('.huo-ring[data-scroll-pinned="true"]') && window.matchMedia('(min-width: 768px)').matches) return;
    const instance = root._huoRing;
    if (!instance || typeof instance.render !== 'function') return;
    const previous = instance.dragAngle || 0;
    instance.dragAngle = previous - 4;
    instance.render(true);
    window.setTimeout(() => {
      instance.dragAngle = previous;
      instance.render(true);
    }, 650);
  }

  function hintSplide(el) {
    if (hinted.has(el) || el.closest('.shopify-section-product-section')) return;
    hinted.add(el);
    const track = el.querySelector('[data-ref="main-slider"] .splide__track, .splide__track');
    if (!track || !track.animate) return;
    track.animate(
      [{ transform: 'translateX(0)' }, { transform: 'translateX(-8px)' }, { transform: 'translateX(0)' }],
      { duration: 1150, easing: 'cubic-bezier(.22,1,.36,1)' }
    );
  }

  function observeHint(target, fn) {
    if (!motionHint || !('IntersectionObserver' in window)) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio > 0.45) {
          window.setTimeout(() => fn(target), 420);
          obs.disconnect();
        }
      });
    }, { threshold: [0.45] });
    obs.observe(target);
  }

  function init() {
    const nativeSelectors = [
      '.five-modes-carousel__track',
      '.huo-finishes-stage__track',
      '.huo-final-studio__grid',
      '.huo-page-exp__visual-grid',
      '.huo-page-exp__moments',
      '.huo-page-exp__finishes'
    ].join(',');

    document.querySelectorAll(nativeSelectors).forEach((track) => {
      if (track.dataset.huoAutoInit === 'true') return;
      track.dataset.huoAutoInit = 'true';
      bindPause(track, nativeAdvance);
      observeHint(track, hintNative);
    });

    document.querySelectorAll('.huo-ring, .huo-ringc').forEach((root) => {
      if (root.dataset.huoAutoInit === 'true') return;
      root.dataset.huoAutoInit = 'true';
      bindPause(root, ringAdvance);
      observeHint(root, hintRing);
    });

    document.querySelectorAll('slider-component').forEach((el) => {
      if (el.dataset.huoAutoInit === 'true') return;
      el.dataset.huoAutoInit = 'true';
      bindPause(el, splideAdvance);
      observeHint(el, hintSplide);
    });
  }

  document.addEventListener('visibilitychange', () => {
    document.querySelectorAll('[data-huo-auto-init="true"]').forEach((el) => {
      if (document.hidden) stop(el);
    });
    if (!document.hidden) init();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.setTimeout(init, 1200);
  document.addEventListener('shopify:section:load', () => window.setTimeout(init, 80));
})();
